import { useId, useState, type ReactNode } from 'react'
import styles from './ActionTooltip.module.scss'

export type ActionTooltipProps = {
    content: ReactNode
    children: ReactNode
    enabled?: boolean
    className?: string
}

/**
 * Lightweight hover/focus tooltip for explaining why an action is blocked.
 * Cloned from the claim-site ActionTooltip (CSS-only, no motion dep).
 */
export const ActionTooltip = ({
    content,
    children,
    enabled = true,
    className = '',
}: ActionTooltipProps) => {
    const [open, setOpen] = useState(false)
    const tooltipId = useId()
    const isVisible = enabled && open && Boolean(content)

    return (
        <span
            className={`${styles.root} ${className}`.trim()}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
        >
            <span aria-describedby={isVisible ? tooltipId : undefined} className={styles.trigger}>
                {children}
            </span>
            {isVisible ? (
                <span id={tooltipId} role="tooltip" className={styles.tooltip}>
                    {content}
                    <span className={styles.arrow} />
                </span>
            ) : null}
        </span>
    )
}
